import { EmptyContentWrapper } from '@juvare/common-web-ui/EmptyContentWrapper';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../hooks';
export const NoShifts = ({ description, onCreateNewShift, onMissionClose }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(EmptyContentWrapper, { description: description },
        React.createElement(React.Fragment, null,
            onCreateNewShift ? (React.createElement(Button, { startIcon: React.createElement(AddIcon, null), variant: 'contained', onClick: onCreateNewShift, "data-test": 'add-new-shift-button' }, t('missions.addShift'))) : null,
            onCreateNewShift && onMissionClose ? `${t('missions.or')}` : null,
            onMissionClose ? (React.createElement(Button, { onClick: onMissionClose, "data-test": 'mission-close-button' }, t('missions.closeMission'))) : null)));
};
